import type { ComponentProps } from 'react';
import { Link } from '@tanstack/react-router';

import { cn } from '@keboola/design';

type Props = Omit<ComponentProps<typeof Link>, 'className'> & { className?: string };

/**
 * Router link styled like `@keboola/design`'s `Link`.
 *
 * - Design's `Link` is a plain `<a>` defaulting to `target="_blank"`.
 * - A bare TanStack `Link` is unstyled; preflight strips even its underline.
 * - `className` is string-only: `cn` would stringify TanStack's function form.
 */
export function TextLink({ className, ...props }: Props) {
  return (
    <Link
      {...props}
      className={cn(
        'tw:text-primary tw:underline tw:hover:text-primary/90 tw:hover:no-underline',
        className,
      )}
    />
  );
}
